import { timelineNodes } from "@/mocks/home";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1360px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 border-b border-background-300 pb-6 mb-10">
          <div>
            <span className="text-[11px] font-label tracking-[0.24em] text-primary-600">FULL TIMELINE</span>
            <h2 className="mt-2 font-heading text-3xl md:text-[2.4rem] font-black text-foreground-950">
              从起因到发酵，全程还原
            </h2>
          </div>
          <p className="md:max-w-md text-sm leading-relaxed text-foreground-500">
            每一个节点都标注了公开时间与来源方向，你可以按顺序读完，也可以只看其中的反转节点。
          </p>
        </div>

        <ol className="relative">
          {timelineNodes.map((node, index) => (
            <li key={`${node.date}-${node.title}`} className="relative grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 pb-8 md:pb-10 last:pb-0">
              <div className="md:col-span-3 flex md:flex-col md:items-end md:text-right gap-3 md:gap-1.5">
                <span className="font-heading text-xl md:text-2xl font-black text-foreground-950 tabular-nums">{node.date}</span>
                <span className="text-xs font-label text-foreground-400 tabular-nums">{node.time}</span>
                <span className="md:mt-1 inline-block rounded-full bg-accent-100 text-accent-900 px-2.5 py-0.5 text-[11px] font-label whitespace-nowrap h-fit">
                  {node.tag}
                </span>
              </div>

              <div className="hidden md:flex md:col-span-1 justify-center relative">
                <span className="absolute top-0 bottom-0 w-px bg-background-300" />
                <span
                  className={`relative z-10 mt-2 w-3.5 h-3.5 rounded-full border-2 ${
                    index === 0 ? "bg-primary-500 border-primary-500" : "bg-background-50 border-secondary-400"
                  }`}
                />
              </div>

              <article className="md:col-span-8 flex flex-col sm:flex-row gap-5 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="w-full sm:w-[150px] h-[190px] sm:h-[150px] shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={node.img}
                    alt={node.title}
                    title={`热点黑料时间线 ${node.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950">{node.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-label text-primary-600">
                    <i className="ri-file-text-line" />
                    查看此节点公开材料
                  </span>
                </div>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}